<template>
    <div id="appointment-deposit-setting" class="shadow-md rounded-item">
        <vx-card>
            <h4 class="text-2xl font-bold mb-6">Setting Deposit Type</h4>
            <div class="flex align-center mb-12 pb-2">
                <div class="mr-12 pr-base">
                    <p class="mb-2">Percentage deposit</p>
                    <div class="flex align-center">
                        <vs-radio v-model="deposit_type" vs-name="deposit_type" vs-value="percent" class="flex align-center m-0 pr-4">%</vs-radio>
                        <vs-input min="0" :max="max['percent']" v-model="deposit_value['percent']" v-on:keypress="isNumber($event, 'percent')"></vs-input>
                    </div>
                </div>
                <div>
                    <p class="mb-2">Fixed deposit amount</p>
                    <div class="flex align-center">
                        <vs-radio v-model="deposit_type" vs-name="deposit_type" vs-value="fixed" class="flex align-center m-0 pr-4">$</vs-radio>
                        <vs-input min="0" :max="max['fixed']" v-model="deposit_value['fixed']" v-on:keypress="isNumber($event, 'fixed')"></vs-input>
                    </div>
                </div>
            </div>
            <h4 class="text-2xl font-bold mb-6">Setting Cancel Policy</h4>
            <div class="flex mb-6">
                <p>Customer's appointment is not allowed to cancel within: </p>
                <vs-switch v-model="cancel_policy" class="ml-base mr-3" />
                <span>Allow</span>
            </div>

            <vs-radio v-model="cancel_time_type" vs-name="cancel_time" vs-value="24" class="flex align-center m-0 mb-4">24 Hours</vs-radio>
            <vs-radio v-model="cancel_time_type" vs-name="cancel_time" vs-value="48" class="flex align-center m-0 mb-4">48 Hours</vs-radio>
            <div class="flex align-start custom-block">
                <vs-radio v-model="cancel_time_type" vs-name="cancel_time" vs-value="custom" class="flex align-center m-0 pr-4">Custom Hours</vs-radio>
                <vs-input min="0" :max="max['fixed']" v-model="custom_time_value" class="ml-2 custom-input" v-on:keypress="isNumber($event)" v-show="cancel_time_type == 'custom'"></vs-input>
            </div>

            <div class="flex justify-center my-base pt-base">
                <vs-button type="filled" color="primary" style="min-width: 140px" @click="updateDepositSetting">Save</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: "appointment-deposit-setting",
    data() {
        return {
            deposit_type: 'fixed',
            deposit_value: {
                percent: 0,
                fixed: 20
            },
            max: {
                percent: 100,
                fixed: 99999999999
            },
            cancel_policy: false,
            cancel_time_type: 24,
            custom_time_value: 0,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: '',
            active_deposit: false
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        },
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' Appointment Deposit Setting Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        isOverMax(key, type) {
            if(type && parseFloat(this.deposit_value[type] + '' + key) > this.max[type]) {
                return true;
            } else if(!type && parseFloat(this.custom_time_value + '' + key) > this.max['fixed']) {
                return true;
            }
            return false;
        },
        isNumber: function(evt, type = null) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            // if ((charCode > 31 && (charCode < 48 || charCode > 57)) || parseInt(this.discount_value + '' + evt.key) > this.max) {
            if ((charCode > 31 &&  (charCode < 48 || charCode > 57) && charCode !== 46) 
                || (type && charCode == 46 && this.deposit_value[type].toString().indexOf(".") != -1)
                || (type && (charCode >= 48 && charCode <= 57) && this.deposit_value[type].toString().indexOf(".") != -1 && (this.deposit_value[type].toString().substring(this.deposit_value[type].toString().indexOf(".") + 1)).length == 2) 
                || (!type && charCode == 46) || this.isOverMax(evt.key, type)) {
                evt.preventDefault();
            } else {
                if(type && (this.deposit_value[type] === "0" || this.deposit_value[type] === 0) && charCode != 46) {
                    this.deposit_value[type] = "";
                } else if(!type && this.custom_time_value == 0) {
                    this.custom_time_value = "";
                }

                if(type && (!this.deposit_value[type] || this.deposit_value[type] == "") && charCode == 46) {
                    this.deposit_value[type] = "0";
                }
                return true;
            }
        },
        updateDepositSetting() {
            if(!this.deposit_value[this.deposit_type] || this.deposit_value[this.deposit_type] == "") {
                this.deposit_value[this.deposit_type] = 0;
            }
            if(this.cancel_time_type == 'custom' && (!this.custom_time_value || this.custom_time_value == "")) {
                this.custom_time_value = 0;
            }
            let obj = {
                key: 'config.appointment.deposit_setting',
                value: JSON.stringify({
                    status: this.active_deposit ? 1 : 0,
                    deposit_type: this.deposit_type,
                    deposit_value: this.deposit_value[this.deposit_type],
                    cancel_policy: this.cancel_policy ? 1 : 0,
                    cancel_policy_time: this.cancel_time_type != 'custom' ? 
                                        (parseInt(this.cancel_time_type) * 60) :
                                        parseInt(this.custom_time_value * 60)
                })
            }
            // console.log(obj);
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Appointment Deposit Setting Success',
                    color:'success',
                    position:'top-right'})
            })
        }
    },
    created() {
        const obj = {
            key: 'config.appointment.deposit_setting'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then((res) => {
            this.loaded_data_num++;
            let data = this.$store.getters["appSetting/keyStorage"];
            let deposit_setting = JSON.parse(data.value);
            this.deposit_value['percent'] = 0;
            this.deposit_value['fixed'] = 0;
            this.active_deposit = false;
            if(deposit_setting) {
                this.deposit_type = deposit_setting.deposit_type;
                this.deposit_value[this.deposit_type] = deposit_setting.deposit_value;
                this.cancel_policy = deposit_setting.cancel_policy == 1 ? true : false;
                let cancel_policy_hour = deposit_setting.cancel_policy_time / 60;
                if(cancel_policy_hour == 24 || cancel_policy_hour == 48) {
                    this.cancel_time_type = cancel_policy_hour;
                } else {
                    this.cancel_time_type = 'custom';
                    this.custom_time_value = cancel_policy_hour;
                }
                this.active_deposit = deposit_setting.status == 1 ? true : false
            }
        }).catch(() => {
            const obj = {
                key: 'config.appointment.deposit_setting',
                value: JSON.stringify({
                    status: 0,
                    deposit_type: 'fixed',
                    deposit_value: 20,
                    cancel_policy: 0,
                    cancel_policy_time: 1440
                })
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>

<style lang="scss">
#appointment-deposit-setting {
    .vs-radio--label {
        margin-left: 10px;
    }
    .vs-input {
        width: 82px;
        input {
            padding: 0.65rem 0.7rem;
        }

        &.custom-input {
            margin-top: -0.8rem !important;
        }
    }
    .custom-block {
        min-height: 41.19px;
    }
}
</style>